import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Hero from "@/pages/home/components/Hero";
import Categories from "@/pages/home/components/Categories";
import ExcursionsList from "@/pages/home/components/ExcursionsList";
import WhyUs from "@/pages/home/components/WhyUs";
import ContactCTA from "@/pages/home/components/ContactCTA";
import Testimonials from "@/pages/home/components/Testimonials";

export default function Home() {
  return (
    <div className="bg-background-50 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <ExcursionsList />
        <WhyUs />
        <Testimonials />
        <ContactCTA />
      </main>
      <Footer />
    </div>
  );
}